<template>
  <div :class="$router.currentRoute.value.name" id="app">
    <router-view />
  </div>
</template>

<script>

export default {
  data () {
    return {
      vueAppClasses: [],
      refreshing: false,
      registration: null,
      updateExists: false,
    }
  },
  watch: {
    '$store.state.theme' (val) {
      this.toggleClassInBody(val)
    },
  },
  mounted () {
    this.$store.commit('UPDATE_WINDOW_WIDTH', window.innerWidth)
    this.$store.commit('SET_BACKEND', window.config.backend)
    this.$store.commit('SET_URL_BOT', window.config.urlBot)
    this.$store.commit('SET_SOCKET', window.config.SOCKET)
    // this.$store.commit('SET_SENTRY', window.config.ID_SENTRY)
    this.$store.commit('SET_ACTIVE_MODAL_LEAVE_VOTE', false)
    
    let vh = window.innerHeight * 0.01
    // Then we set the value in the --vh custom property to the root of the document
    document.documentElement.style.setProperty('--vh', `${vh}px`)
  },
  async created () {
    window.addEventListener('resize', this.handleWindowResize)
    window.addEventListener('scroll', this.handleScroll)
    document.addEventListener('swUpdated', this.showRefreshUI, { once: true })
    if (navigator.serviceWorker) {
      navigator.serviceWorker.addEventListener('controllerchange', () => {
        if (this.refreshing) return
        this.refreshing = true
        window.location.reload()
      })
    }
  },
  unmounted () {
    window.removeEventListener('resize', this.handleWindowResize)
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    showRefreshUI (e) {
      this.registration = e.detail
      if (!this.registration || !this.registration.waiting) {
        return
      }
      this.registration.waiting.postMessage({ type: 'SKIP_WAITING' })
      this.updateExists = true
    },
    toggleClassInBody (className) {
      if (className == 'dark') {
        if (document.body.className.match('theme-semi-dark')) document.body.classList.remove('theme-semi-dark')
        document.body.classList.add('theme-dark')
      } else if (className == 'semi-dark') {
        if (document.body.className.match('theme-dark')) document.body.classList.remove('theme-dark')
        document.body.classList.add('theme-semi-dark')
      } else {
        if (document.body.className.match('theme-dark')) document.body.classList.remove('theme-dark')
        if (document.body.className.match('theme-semi-dark')) document.body.classList.remove('theme-semi-dark')
      }
    },
    handleWindowResize () {
      this.$store.commit('UPDATE_WINDOW_WIDTH', window.innerWidth)
      document.documentElement.style.setProperty('--vh', `${window.innerHeight * 0.01}px`)
    },
    handleScroll () {
      this.$store.commit('UPDATE_WINDOW_SCROLL_Y', window.scrollY)
    },
  },
}

// if ('Notification' in window && 'serviceWorker' in navigator) {
//   Notification.requestPermission().then(permission => {
//     if (permission === 'granted') {
//       navigator.serviceWorker.ready.then(function(swRegistration) {
//         console.log("swRegistration", swRegistration);
//       });
//     } else {
//       const userConfirmation = confirm("Hace click en el boton permitir para poder interactuar con la herramienta");
//       if (userConfirmation) {
//         Notification.requestPermission().then(newPermission => {
//           if (newPermission === 'granted') {
//             navigator.serviceWorker.ready.then(function(swRegistration) {
//               console.log("swRegistration", swRegistration);
//             });
//           } else {
//             console.error('El usuario sigue sin habilitar las notificaciones');
//           }
//         });
//       } else {
//         console.error('El usuario decidió no habilitar las notificaciones');
//       }
//     }
//   });
// } else {
//   console.error('Notificaciones o serviceWorker no están soportados en este navegador');
// }

if ('Notification' in window && 'serviceWorker' in navigator) {
  if (Notification.permission === 'granted') {
    // El permiso ya fue concedido
    navigator.serviceWorker.ready.then(swRegistration => {
      console.log("Notificaciones habilitadas y Service Worker listo", swRegistration);
    });
  } else if (Notification.permission === 'default') {
    // El permiso aún no ha sido solicitado
    const userConfirmation = confirm("Haz clic en 'Permitir' para habilitar las notificaciones y poder interactuar con la herramienta.");
    if (userConfirmation) {
      Notification.requestPermission().then(permission => {
        if (permission === 'granted') {
          navigator.serviceWorker.ready.then(swRegistration => {
            console.log("Notificaciones habilitadas y Service Worker listo", swRegistration);
          });
        } else {
          console.error('El usuario decidió no habilitar las notificaciones');
        }
      });
    } else {
      console.error('El usuario decidió no interactuar con la solicitud de permisos');
    }
  } else {
    // El permiso ya fue denegado
    console.warn('El permiso de notificaciones fue rechazado previamente. Configúralo en las opciones del navegador.');
  }
} else {
  console.error('Notificaciones o Service Worker no están soportados en este navegador');
}

</script>
